import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import TrustSection from './components/TrustSection';
import CategoryGrid from './components/CategoryGrid';
import GuideSection from './components/GuideSection';
import CTASplit from './components/CTASplit';

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://cssspreadsheet.homes';

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'CSSBuy Spreadsheet Hub',
    url: siteUrl,
    description: 'Discover the best CSSBuy spreadsheet, Kakobuy spreadsheet, Superbuy spreadsheet, and Oopbuy spreadsheet finds. Compare shopping agents, browse 14 product categories, and access verified China shopping links updated daily for 2026.',
    inLanguage: 'en',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: 'https://kaspreadsheet.com/search-{search_term}/name/Shoes.html',
      },
      'query-input': 'required name=search_term',
    },
  };

  return (
    <main className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <Navbar />
      <Hero />
      <TrustSection />
      <CategoryGrid />
      <GuideSection />
      <CTASplit />
      <Footer />
    </main>
  );
}